/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Nov 29 2024
 **/

export function ClearIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.7939 18.1666L13.9998 23.1666H15.3216L15.7456 21.9449H17.2152L17.6445 23.1666H18.9998L17.2058 18.1666H15.7939ZM16.484 19.3397L16.9464 20.9665H16.0264L16.484 19.3397ZM19.8332 23.1666H20.6665V18.1666H19.8332V23.1666ZM21.4998 23.1666H22.3332V18.1666H21.4998V23.1666ZM12.9058 19H6.49984V20.6666H12.3332L12.9058 19ZM10.4224 13.4107C10.7228 13.7111 10.7459 14.1838 10.4918 14.5107L10.4224 14.5893C10.122 14.8897 9.64933 14.9128 9.32242 14.6586L9.24392 14.5893L5.91058 11.2559C5.61018 10.9555 5.58707 10.4828 5.84126 10.1559L5.91058 10.0774L9.24392 6.74408C9.56935 6.41864 10.097 6.41864 10.4224 6.74408C10.7228 7.04448 10.7459 7.51717 10.4918 7.84408L10.4224 7.92259L8.51234 9.8325L15.6701 9.83329C18.8313 9.83329 21.3933 12.4294 21.4966 15.6576L21.4998 15.8602V16.5H19.8332V15.8602C19.8332 13.507 18.0567 11.6 15.8456 11.5038L15.6701 11.5L8.51234 11.4992L10.4224 13.4107Z"
				fill="white"
			/>
		</svg>
	);
}

export function UndoIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11.2558 14.2439C11.5562 14.5443 11.5793 15.017 11.3251 15.3439L11.2558 15.4224C10.9554 15.7228 10.4827 15.7459 10.1558 15.4917L10.0772 15.4224L5.91058 11.2558C5.61018 10.9554 5.58707 10.4827 5.84126 10.1558L5.91058 10.0772L10.0772 5.91058C10.4027 5.58514 10.9303 5.58514 11.2558 5.91058C11.5562 6.21098 11.5793 6.68368 11.3251 7.01059L11.2558 7.08909L8.51234 9.83234L13.8957 9.83313C18.0263 9.83313 21.3803 13.1972 21.4967 17.3826L21.4998 17.6076V21.4998H19.8332V17.6076C19.8332 14.2987 17.2777 11.6115 14.0954 11.5032L13.8957 11.4998L8.51234 11.499L11.2558 14.2439Z"
				fill="white"
			/>
		</svg>
	);
}
export function RedoIcon() {
	return (
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M16.7442 14.2439C16.4438 14.5443 16.4207 15.017 16.6749 15.3439L16.7442 15.4224C17.0446 15.7228 17.5173 15.7459 17.8442 15.4917L17.9228 15.4224L22.0894 11.2558C22.3898 10.9554 22.4129 10.4827 22.1587 10.1558L22.0894 10.0772L17.9228 5.91058C17.5973 5.58514 17.0697 5.58514 16.7442 5.91058C16.4438 6.21098 16.4207 6.68368 16.6749 7.01059L16.7442 7.08909L19.4868 9.83234L14.1043 9.83313C9.97373 9.83313 6.6197 13.1972 6.50329 17.3826L6.50016 17.6076V21.4998H8.16683V17.6076C8.16683 14.2987 10.7222 11.6115 13.9046 11.5032L14.1043 11.4998L19.4885 11.499L16.7442 14.2439Z"
				fill="white"
			/>
		</svg>
	);
}
